import DOMPurify from 'dompurify';

// Rich-text fields in this app are authored with react-draft-wysiwyg and
// rendered back to HTML via draftjs-to-html, so the allowlist only needs to
// cover what that converter actually emits (paragraphs, inline styling,
// lists, links). Anything else - scripts, event handler attributes, iframes -
// is stripped rather than rendered.
const ALLOWED_TAGS = [
  'p', 'br', 'span', 'strong', 'b', 'em', 'i', 'u', 's',
  'ul', 'ol', 'li', 'a', 'blockquote', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
];
const ALLOWED_ATTR = ['href', 'target', 'rel', 'style'];

/**
 * Sanitize HTML produced by the app's rich-text editor before handing it to
 * dangerouslySetInnerHTML. Never render admin-authored HTML without this.
 */
export function sanitizeHtml(html) {
  if (!html) return '-';
  return DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR });
}
